import { observer } from 'mobx-react-lite';
import Image from 'next/image';
import { SearchPlaces } from 'searchPlaces.d';
import { DEFAULT_IMAGE } from 'constants/index';
import * as styles from './PlaceCard.css';

function PlaceCard({ name, location, images, url }: SearchPlaces) {
  return (
    <a href={url} className={styles.cardContainer}>
      <div className={styles.contentWrapper}>
        <div className={styles.imageContainer}>
          <Image
            src={images?.original || DEFAULT_IMAGE}
            alt={`Logo ${name}`}
            width={140}
            height={140}
            className={styles.placeImage}
          />
        </div>
        <div className={styles.infoContainer}>
          <div className={styles.textWrapper}>
            <h3 className={styles.placeName}>{name}</h3>
            {location && (
              <p className={styles.locationText}>
                {`${location.city}, ${location.state}`}
              </p>
            )}
          </div>
        </div>
      </div>
    </a>
  );
}

export default observer(PlaceCard);
